 require('./bootstrap');
window.Vue = require('vue');
import moment from 'moment';
Vue.prototype.moment = moment;
//Vue.component('InfiniteLoading', require('vue-infinite-loading'));
import datetime from 'vuejs-datetimepicker';
Vue.component('datetime', datetime);
import vGoogleTranslate from "v-google-translate";
Vue.use(vGoogleTranslate);
import { Form, HasError, AlertError } from 'vform';
window.Form = Form;
import Gate from "./Gate";
Vue.prototype.$gate = new Gate(window.user);
import Swal from 'sweetalert2';
import multiselect from 'vue-multi-select';
Vue.component('multiselect', multiselect);
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import wysiwyg from "vue-wysiwyg";
import VTooltip from 'v-tooltip'

import Embed from 'v-video-embed'
Vue.use(Embed);

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
Vue.component('vueDropzone', vue2Dropzone);

Vue.use(VTooltip)
Vue.use(wysiwyg, {}); // config is optional. more below
Vue.prototype.$eventHub = new Vue(); // Global event bus
// chartjs package
//require('chart.js');



//import VueSwal from 'vue-swal';
//Vue.component('swal', VueSwal);
import Datepicker from "vue2-datepicker";
Vue.component('datepicker', Datepicker);
const Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    showConfirmButton: false,
    timer: 1000,
    timerProgressBar: true,
    onOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
window.Swal = Swal;
window.Toast = Toast;

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '3px'
  });

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)


/**
 * Routes imports and assigning
 */
import notfound from './components/NotFound.vue'
import headernavbarComponent from './components/headerbar.vue';
import AppComponent from './components/AppComponent.vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import routes from './routes';
import Vue from 'vue';

const router = new VueRouter({
    mode: 'history',
    routes
});
Vue.component('not-found',notfound);
Vue.component('headernavbar-view', headernavbarComponent);
Vue.component('router-outlet', AppComponent);
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('dashboard', require('./components/Dashboard.vue'));
//Vue.component('grafica-component', require('./components/graficos.vue'));
//Vue.component('chart_lessontype', require('./components/dashboard/chart_lessontype.vue').default);
Vue.filter('myDate',function(created){
    return moment(created).format('MMMM Do YYYY');
});
Vue.filter('myDateUs',function(created){
  return moment(created).format('MM/DD/YYYY');
});

Vue.filter('yesno', value => (value ? '<i class="fas fa-check green"></i>' : '<i class="fas fa-times red"></i>'));
const app = new Vue({
    el: '#app',
    router
    
});
Vue.filter('filterYouTubeUrl', function (url, index = 0) {
  if (url.indexOf("embed") > 0) {
      return url;
  } else if (url.indexOf("watch") > 0) {
      return "https://www.youtube.com/embed/" + url.substring(url.indexOf("v=") + 2);
  } else {
      return url;
}
});
